import { Component } from '@angular/core';

@Component({
  selector: 'app-crm-dashboard-list',
  standalone: false,
  templateUrl: './crm-dashboard-list.component.html',
  styleUrl: './crm-dashboard-list.component.css'
})
export class CrmDashboardListComponent {

}
